import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromCompanies from './companies.reducer';
import { CompaniesEffects } from './companies.effects';
import { CompaniesFacade } from './companies.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromCompanies.COMPANIES_FEATURE_KEY,
      fromCompanies.reducer,
    ),
    EffectsModule.forFeature([CompaniesEffects]),
  ],
  providers: [CompaniesFacade],
})
export class StoreCompaniesFirebaseModule {}
